export const DISCORD_LINK = 'https://dub.composio.dev/discord'
